import { Box, Typography, Divider, Card, CardContent } from '@mui/material';
import MfaOptions from './MfaOptions';
import SecurityIcon from '@mui/icons-material/Security';

export default function Set2FA({ onSuccess, onFailure }) {
  const handle2FASetupSuccess = () => {
    onSuccess();
  };

  const handle2FASetupFailure = (message) => {
    onFailure(message);
  };

  return (
    <Card
      elevation={3}
      sx={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        borderRadius: 2,
        maxHeight: '100%',
        overflow: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <SecurityIcon fontSize="large" />
        <Typography variant="h5" fontWeight="600">
          Sicherheitseinrichtung
        </Typography>
      </Box>

      <CardContent>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" fontWeight="600" gutterBottom>
            Zwei-Faktor-Authentifizierung aktivieren
          </Typography>

          <Typography variant="body1">
            Um Ihren Account zu schützen, benötigen wir einen zweiten
            Sicherheitsfaktor neben Ihrem Passwort. Diese zusätzliche
            Sicherheitsmaßnahme schützt Ihren Account vor unbefugtem Zugriff.
          </Typography>

          <Typography variant="body1">
            Sie <b> müssen </b> die Zwei-Faktor-Authentifizierung einrichten,
            bevor Sie Ihren Account nutzen können.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <MfaOptions
            onSetupSuccess={handle2FASetupSuccess}
            onSetupFailure={handle2FASetupFailure}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
